import { useSelector } from 'react-redux'

import ChartBox from '../../../components/ReusableComponents/Charts/Inslghts/ChartBox/index'
import MultiBarCard from '../../../components/ReusableComponents/Charts/Inslghts/MultiBar/index'
import { OTA_COMISSION_PERCENT } from '../../../utils/insightsHelpers'
import { formatNumberAsThousands } from '../../../utils/priceHelpers'
import styles from './OTA.module.scss'

const OTA = () => {
  const otaPerformances = useSelector(s => s.insights.otaPerformances.last12Months)

  if (!otaPerformances || !otaPerformances.length) {
    return null
  }

  return (
    <>
      <div className={styles.row}>
        {otaPerformances && (
          <ChartBox>
            <div className={styles.chartInfoContainer}>
              <div className={styles.chartInfo}>
                <div className={styles.chartInfoTitle}>
                  OTA commissions
                  <br /> paid in last 12 months
                </div>
                <div className={styles.chartInfoValue}>
                  $
                  {formatNumberAsThousands(
                    Object.values(otaPerformances)
                      .map(o => Object.values(o).filter(v => typeof v === 'number'))
                      .flat()
                      .reduce((p, c) => p + c, 0)
                  )}
                </div>
                <div className={styles.chartInfoDesc}>
                  Based on average {OTA_COMISSION_PERCENT}% commission
                </div>
              </div>
              <div className={styles.chartHolder}>
                <MultiBarCard
                  yLabel="commission ($)"
                  data={Object.values(otaPerformances)}
                  barSize={10}
                  customYLabel
                  noWrapper
                  height={200}
                  unit="$"
                />
              </div>
            </div>
          </ChartBox>
        )}
      </div>
    </>
  )
}

export default OTA
